export enum TemplateControlType {
    None = 0,
    PlainText = 1,
    HtmlText = 2,
    Image = 3,
    SiteMap = 6,
}
